import React, { FC } from 'react';
import { StyledProgressBar } from './ProgressBar.styled';

type ProgressBarProps = {
  progress: number;
  fullWidth?: boolean;
  style?: React.CSSProperties;
};

const ProgressBar: FC<ProgressBarProps> = ({ progress, fullWidth = false, style }) => {
  return <StyledProgressBar value={progress} fullWidth={fullWidth} style={style} />;
};

export default ProgressBar;
